import { FEATURE_REGISTRY } from '../constants/feature-registry';
import { useSubscription } from './useSubscription';

const EARLY_ACCESS_IDS = FEATURE_REGISTRY
  .filter((feature) => feature.stage === 'early_access')
  .map((feature) => feature.id);

/**
 * A tutor is in early access when any early-access flag is on for their account.
 * Support itself is available to every tutor; this only changes how visible it is.
 */
export function useIsEarlyAccess(): { earlyAccess: boolean; loading: boolean } {
  const { subscription, loading } = useSubscription();
  const enabled = subscription?.subscription?.enabledFeatures || [];
  return {
    earlyAccess: enabled.some((id) => EARLY_ACCESS_IDS.includes(id)),
    loading,
  };
}
